import { defaultStatus } from "../../screen/constant/defaultStatus";
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
  REQUEST_OTP_REQUEST,
  REQUEST_OTP_SUCCESS,
  REQUEST_OTP_FAILURE,
  RESEND_OTP_REQUEST,
  RESEND_OTP_SUCCESS,
  RESEND_OTP_FAILURE,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
  ADMIN_ADD_REQUEST,
  ADMIN_ADD_SUCCESS,
  ADMIN_ADD_FAILURE,
  ADMIN_EDIT_REQUEST,
  ADMIN_EDIT_SUCCESS,
  ADMIN_EDIT_FAILURE,
  ADMIN_VIEW_REQUEST,
  ADMIN_VIEW_SUCCESS,
  ADMIN_VIEW_FAILURE,
  ADMIN_DELETE_REQUEST,
  ADMIN_DELETE_SUCCESS,
  ADMIN_DELETE_FAILURE,
  AUTH_RESET_STATE,
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_REQUEST,
  REFRESH_TOKEN_REQUEST,
  REFRESH_TOKEN_SUCCESS,
  REFRESH_TOKEN_FAILURE,
  RESET_REFRESH_TOKEN_STATE,
  MOBILE_OTP_REQUEST,
  MOBILE_OTP_SUCCESS,
  MOBILE_OTP_FAILURE,
  VERIFY_MOBILE_OTP_REQUEST,
  VERIFY_MOBILE_OTP_SUCCESS,
  VERIFY_MOBILE_OTP_FAILURE,
} from "./AuthTypes";

const initialState = {
  user: { ...defaultStatus, otpVerified: false },
  newUser: { ...defaultStatus },
  registerOtp: { ...defaultStatus },
  forgotPassword: { ...defaultStatus },
  requestOtp: { ...defaultStatus },
  requestMobileOtp: { ...defaultStatus },
  registerMobileOtp: { ...defaultStatus },
  resendOtp: { ...defaultStatus },
  addAdmin: { ...defaultStatus },
  editAdmin: { ...defaultStatus },
  deleteAdmin: { ...defaultStatus },
  viewAdmin: { ...defaultStatus },
  changePassword: { ...defaultStatus },
  refreshToken: { ...defaultStatus },
};

const AuthReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    //Login
    case LOGIN_REQUEST:
      return {
        ...state,
        user: { ...defaultStatus, inProgress: true, ...payload },
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        user: { ...defaultStatus, success: true, ...payload },
      };

    case LOGIN_FAILURE:
      return {
        ...state,
        user: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Logout
    case LOGOUT:
      return {
        ...state,
        user: { ...defaultStatus },
      };

    //Register
    case REGISTER_REQUEST:
      return {
        ...state,
        newUser: { ...defaultStatus, inProgress: true, ...payload },
      };
    case REGISTER_SUCCESS:
      return {
        ...state,
        newUser: { ...defaultStatus, success: true, ...payload },
      };
    case REGISTER_FAILURE:
      return {
        ...state,
        newUser: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          errorFields: payload?.errorFields || null,
          ...payload,
        },
      };

    //Request OTP
    case REQUEST_OTP_REQUEST:
      return {
        ...state,
        requestOtp: { ...defaultStatus, inProgress: true, ...payload },
      };
    case REQUEST_OTP_SUCCESS:
      return {
        ...state,
        requestOtp: { ...defaultStatus, success: true, ...payload },
      };

    case REQUEST_OTP_FAILURE:
      return {
        ...state,
        requestOtp: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Verify OTP
    case VERIFY_OTP_REQUEST:
      return {
        ...state,
        registerOtp: { ...defaultStatus, inProgress: true, ...payload },
      };

    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        registerOtp: {
          ...defaultStatus,
          ...payload,
          success: true,
          error: false,
          progress: false,
        },
      };

    case VERIFY_OTP_FAILURE:
      return {
        ...state,
        registerOtp: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Request Mobile OTP
    case MOBILE_OTP_REQUEST:
      return {
        ...state,
        requestMobileOtp: { ...defaultStatus, inProgress: true, ...payload },
      };
    case MOBILE_OTP_SUCCESS:
      return {
        ...state,
        requestMobileOtp: { ...defaultStatus, success: true, ...payload },
      };

    case MOBILE_OTP_FAILURE:
      return {
        ...state,
        requestMobileOtp: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Verify Mobile OTP
    case VERIFY_MOBILE_OTP_REQUEST:
      return {
        ...state,
        registerMobileOtp: { ...defaultStatus, inProgress: true, ...payload },
      };

    case VERIFY_MOBILE_OTP_SUCCESS:
      return {
        ...state,
        registerMobileOtp: {
          ...defaultStatus,
          ...payload,
          success: true,
          error: false,
          progress: false,
        },
      };

    case VERIFY_MOBILE_OTP_FAILURE:
      return {
        ...state,
        registerMobileOtp: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Resend OTP
    case RESEND_OTP_REQUEST:
      return {
        ...state,
        resendOtp: { ...defaultStatus, inProgress: true, ...payload },
      };
    case RESEND_OTP_SUCCESS:
      return {
        ...state,
        resendOtp: { ...defaultStatus, success: true, ...payload },
      };
    case RESEND_OTP_FAILURE:
      return {
        ...state,
        resendOtp: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Update Password
    case UPDATE_PASSWORD_REQUEST:
      return {
        ...state,
        forgotPassword: { ...defaultStatus, inProgress: true, ...payload },
      };
    case UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        forgotPassword: { ...defaultStatus, success: true, ...payload },
      };
    case UPDATE_PASSWORD_FAILURE:
      return {
        ...state,
        forgotPassword: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Change Password
    case CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        changePassword: { ...defaultStatus, inProgress: true, ...payload },
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePassword: { ...defaultStatus, success: true, ...payload },
      };
    case CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        changePassword: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Add Admin
    case ADMIN_ADD_REQUEST:
      return {
        ...state,
        addAdmin: { ...defaultStatus, inProgress: true, ...payload },
      };

    case ADMIN_ADD_SUCCESS:
      return {
        ...state,
        addAdmin: { ...defaultStatus, success: true, ...payload },
      };

    case ADMIN_ADD_FAILURE:
      return {
        ...state,
        addAdmin: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Edit Admin
    case ADMIN_EDIT_REQUEST:
      return {
        ...state,
        editAdmin: { ...defaultStatus, inProgress: true, ...payload },
      };

    case ADMIN_EDIT_SUCCESS:
      return {
        ...state,
        editAdmin: {
          ...defaultStatus,
          success: true,
          updatedAdminData: action.payload,
          ...payload,
        },
      };

    case ADMIN_EDIT_FAILURE:
      return {
        ...state,
        editAdmin: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //View Admin
    case ADMIN_VIEW_REQUEST:
      return {
        ...state,
        viewAdmin: { ...defaultStatus, inProgress: true, ...payload },
      };

    case ADMIN_VIEW_SUCCESS:
      return {
        ...state,
        viewAdmin: { ...defaultStatus, success: true, ...payload },
      };

    case ADMIN_VIEW_FAILURE:
      return {
        ...state,
        viewAdmin: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Delete Admin
    case ADMIN_DELETE_REQUEST:
      return {
        ...state,
        deleteAdmin: { ...defaultStatus, inProgress: true, ...payload },
      };
    case ADMIN_DELETE_SUCCESS:
      return {
        ...state,
        deleteAdmin: { ...defaultStatus, success: true, ...payload },
      };
    case ADMIN_DELETE_FAILURE:
      return {
        ...state,
        deleteAdmin: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Refresh Token
    case REFRESH_TOKEN_REQUEST:
      return {
        ...state,
        refreshToken: { ...defaultStatus, inProgress: true, ...payload },
      };

    case REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        refreshToken: { ...defaultStatus, success: true, ...payload },
      };

    case REFRESH_TOKEN_FAILURE:
      return {
        ...state,
        refreshToken: {
          ...defaultStatus,
          error: true,
          errormessage: payload?.errormessage || null,
          ...payload,
        },
      };

    //Reset Refresh Token
    case RESET_REFRESH_TOKEN_STATE:
      return {
        ...initialState,
      };

    //Reset
    case AUTH_RESET_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default AuthReducer;
